import { useEffect } from "react";
import {
  List,
  Typography,
  ListItemText,
  ListSubheader,
  ListItemButton,
} from "@mui/material";
import { useSetAtom } from "jotai";
import { shouldCloseMenuAtom } from "atoms";
import CustomMenu from "./CustomMenu";
import { CustomMenuDropdownProps } from "shared/models/custom-menu-dropdown";
import { SSMLMenuColors } from "shared/constants";

export default function PresetCustomMenu({
  presetHeader,
  presetValues,
  customHeader,
  customTextFieldPlaceholder = "",
  showPresetMenuList,
  showCustomTextField,
  handleClick,
  selectedUnit,
  setSelectedUnit,
  unitOptions,
  isNumberType = true,
  allowNegativeCustomValue,
  allowMathSymbols,
  unitPlaceholders,
  textFieldWidth,
  showCheckButton = false,
  defaultValue = "",
  value,
  activeValue = "",
  isCustomValueActive = false,
}: CustomMenuDropdownProps): JSX.Element {
  const setShouldCloseMenu = useSetAtom(shouldCloseMenuAtom);

  useEffect(() => {
    setShouldCloseMenu?.(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {showPresetMenuList && (
        <List
          sx={{
            width: "100%",
          }}
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              <Typography variant="subtitle2" sx={{ py: 1 }}>
                {presetHeader}
              </Typography>
            </ListSubheader>
          }
        >
          {/* Preset values */}
          {presetValues.map((presetValue, index) => {
            const isActive = activeValue === presetValue.value;
            return (
              <ListItemButton
                id={`preset-value-${index}`}
                sx={{
                  py: 0.5,
                  pl: isActive ? "36px" : "16px",
                  position: "relative",
                  backgroundColor: isActive
                    ? SSMLMenuColors.ActiveBackground
                    : "transparent",
                  "&::before": isActive
                    ? {
                        content: '""',
                        position: "absolute",
                        left: "16px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        width: "8px",
                        height: "8px",
                        backgroundColor: "rgba(0, 134, 103, 1)",
                        borderRadius: "50%",
                      }
                    : {},
                }}
                key={presetValue.value}
                onClick={() => handleClick?.(presetValue.value)}
              >
                <ListItemText
                  primary={
                    <Typography>{`${presetValue.label} (${presetValue.value})`}</Typography>
                  }
                />
              </ListItemButton>
            );
          })}
        </List>
      )}
      {showCustomTextField && (
        <CustomMenu
          customHeader={customHeader}
          customTextFieldPlaceholder={customTextFieldPlaceholder}
          handleClick={handleClick}
          isNumberType={isNumberType}
          allowNegativeCustomValue={allowNegativeCustomValue}
          allowMathSymbols={allowMathSymbols}
          showBorder={showPresetMenuList}
          unitOptions={unitOptions}
          selectedUnit={selectedUnit}
          setSelectedUnit={setSelectedUnit}
          unitPlaceholders={unitPlaceholders}
          textFieldWidth={textFieldWidth}
          showCheckButton={showCheckButton}
          defaultValue={defaultValue}
          value={value}
          isCustomValueActive={isCustomValueActive}
        />
      )}
    </>
  );
}
